/**
 * @generated SignedSource<<205346367a48121b8ea38961b3f2b666>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutPaymentReducer_buyer$data = {
  readonly firstValidShippingAddress: {
    readonly country: string | null;
  } | null;
  readonly isTrade: boolean | null;
  readonly profile: {
    readonly country: string | null;
    readonly displayName: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly wallet: {
    readonly hasBankAccounts: boolean | null;
    readonly hasCreditCards: boolean | null;
    readonly paymentMethods: ReadonlyArray<{
      readonly paymentMethod: {
        readonly __typename: "ACH";
        readonly token: string | null;
      } | {
        readonly __typename: "CreditCard";
        readonly token: string | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null;
      readonly shippingAddresses: ReadonlyArray<{
        readonly serviceId: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "checkoutPaymentReducer_buyer";
};
export type checkoutPaymentReducer_buyer$key = {
  readonly " $data"?: checkoutPaymentReducer_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutPaymentReducer_buyer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutPaymentReducer_buyer"
};

(node as any).hash = "3b65dd83499b750b9b6254ab3bb678ec";

export default node;
